// Libraries
import { object, string } from 'yup'
// Local Functions
const areArraysEqual = (arrayA, arrayB) => arrayA.length === arrayB.length && arrayA.every((item, index) => Object.keys(item).every(key => item[key] === arrayB[index][key]))

export const USE_DEFINED_SKILL_SCHEMA = (initialState, currentSkills) => object().shape({
  skill: string()
    .when([], (level, schema) => {
      if (currentSkills && currentSkills.length > 0) {
        return !areArraysEqual(initialState, currentSkills) ? schema.nullable(true) : schema.required('Please add a new value or modify the current ones to save')
      }
      return schema.required('Required')
    }),
  level: string().when(['skill'], (skill, schema) => {
    const skillAsString = Array.isArray(skill) ? skill[0] : skill
    return (skillAsString && skillAsString !== '' ? schema.required('Required') : schema.nullable(true))
  })
})
